"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgNavigation = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M17.953 23.708l5.29 1.322a1 1 0 01.727.727l1.322 5.29 6.606-13.945-13.945 6.606zm4.222 3.117l-7.418-1.855c-.91-.228-1.034-1.472-.185-1.874l19-9c.85-.402 1.734.483 1.332 1.332l-9 19c-.402.849-1.646.725-1.874-.185l-1.855-7.418z",
    id: "navigation_svg__a"
  }));
};

var _default = SvgNavigation;
exports.default = _default;